import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { drapcodeIcon } from '../custom/icon-library';
import {
  AIRTABLE,
  DRAPCODE,
  REST_API,
  ZAPIER,
  CHAT_GPT,
  APP_WRITE,
  XANO,
  SALESFORCE,
} from 'drapcode-constant';
import ImageLink from '../ui/ImageLink';
import { apiTypeImages, snakeCaseToTitleCase } from '../utils/api_utils';

const ExternalSourceHeaderNav = ({
  title,
  titleIcon,
  headers,
  activeTab,
  projectId,
  version,
  enableRestApi,
  enableZapier,
  enableChatGpt = false,
  enableAppwrite,
  enableSupabase,
  enableXata,
  enableXano,
  enableDrapcode,
  toggle,
  enableDirectus,
  enableAirtable,
  enableSalesForce,
}) => {
  const showHeaders = (header) => {
    const title = snakeCaseToTitleCase(header);
    let image = apiTypeImages[header];
    if (image) {
      return (
        <li className={`nav-item ${activeTab === header && 'active'}`} key={header}>
          <ImageLink tab={header} image={image} alt={title} text={title} toggle={toggle} />
        </li>
      );
    } else {
      return '';
    }
  };
  return (
    <nav className="navbar navbar-expand-lg bg-primary">
      <div className="container">
        <div className="navbar-translate">
          <div className="navbar-brand">
            <i className={`wb ${drapcodeIcon(titleIcon)}`} size={'md'}></i>&nbsp;
            <span>{title}</span>
          </div>
        </div>
        <div className="collapse navbar-collapse">
          <ul className="navbar-nav ml-auto">
            {enableRestApi && (
              <li className={`nav-item ${activeTab === REST_API && 'active'}`}>
                <ImageLink
                  tab={REST_API}
                  image="rocket.svg"
                  alt="REST API"
                  text="REST API"
                  toggle={toggle}
                />
              </li>
            )}
            {enableDrapcode && (
              <li className={`nav-item ${activeTab === DRAPCODE && 'active'}`}>
                <ImageLink
                  tab={DRAPCODE}
                  image="drapcode.png"
                  alt="DrapCode"
                  text="DrapCode"
                  toggle={toggle}
                />
              </li>
            )}

            {headers.map((header) => showHeaders(header))}
            {enableZapier && (
              <li className={`nav-item ${activeTab === ZAPIER && 'active'}`}>
                <Link to={`/externalapi/${version}/v/${projectId}/zapier`} className="nav-link">
                  <span className="circle">
                    <img
                      src={require('../dataSource/img/zapier.svg')}
                      width="18"
                      height="18"
                      alt={'Zapier'}
                    />
                  </span>
                  &nbsp;Zapier
                </Link>
              </li>
            )}
            {enableChatGpt && (
              <li className={`nav-item ${activeTab === CHAT_GPT && 'active'}`}>
                <Link to={`/externalapi/${version}/v/${projectId}/chatGpt`} className="nav-link">
                  <span className="circle">
                    <img
                      src={require('../dataSource/img/chatgpt-logo.png')}
                      width="18"
                      height="18"
                      alt={'ChatGPT'}
                    />
                  </span>
                  &nbsp;ChatGPT
                </Link>
              </li>
            )}
            {enableAppwrite && (
              <li className={`nav-item ${activeTab === APP_WRITE && 'active'}`}>
                <Link to={`/externalapi/${version}/v/${projectId}/appwrite`} className="nav-link">
                  <span className="circle">
                    <img
                      src={require('../dataSource/img/appwrite.svg')}
                      width="18"
                      height="18"
                      alt={'Appwrite'}
                    />
                  </span>
                  &nbsp;Appwrite
                </Link>
              </li>
            )}
            {enableXano && (
              <li className={`nav-item ${activeTab === XANO && 'active'}`}>
                <Link to={`/externalapi/${version}/v/${projectId}/xano`} className="nav-link">
                  <span className="circle">
                    <img
                      src={require('../dataSource/img/xano.svg')}
                      width="18"
                      height="18"
                      alt={'Xano'}
                    />
                  </span>
                  &nbsp;Xano
                </Link>
              </li>
            )}
            {enableSupabase && (
              <li className={`nav-item ${activeTab === `SUPABASE` && 'active'}`}>
                <Link to={`/externalapi/${version}/v/${projectId}/supabase`} className="nav-link">
                  <span className="circle">
                    <img
                      src={require('../dataSource/img/supabase.svg')}
                      width="18"
                      height="18"
                      alt={'Supabase'}
                    />
                  </span>
                  &nbsp;Supabase
                </Link>
              </li>
            )}
            {enableXata && (
              <li className={`nav-item ${activeTab === `XATA` && 'active'}`}>
                <Link to={`/externalapi/${version}/v/${projectId}/xata`} className="nav-link">
                  <span className="circle">
                    <img
                      src={require('../dataSource/img/xata.svg')}
                      width="18"
                      height="18"
                      alt={'Xata'}
                    />
                  </span>
                  &nbsp;Xata
                </Link>
              </li>
            )}
            {enableDirectus && (
              <li className={`nav-item ${activeTab === `DIRECTUS` && 'active'}`}>
                <Link to={`/externalapi/${version}/v/${projectId}/directus`} className="nav-link">
                  <span className="circle">
                    <img
                      src={require('../dataSource/img/directus.svg')}
                      width="18"
                      height="18"
                      alt={'Directus'}
                    />
                  </span>
                  &nbsp;Directus
                </Link>
              </li>
            )}
            {enableAirtable && (
              <li className={`nav-item ${activeTab === AIRTABLE && 'active'}`}>
                <Link to={`/externalapi/${version}/v/${projectId}/airtable`} className="nav-link">
                  <span className="circle">
                    <img
                      src={require('../dataSource/img/airtable.svg')}
                      width="18"
                      height="18"
                      alt="Airtable"
                    />
                  </span>
                  &nbsp;Airtable
                </Link>
              </li>
            )}
            {enableSalesForce && (
              <li className={`nav-item ${activeTab === SALESFORCE && 'active'}`}>
                <Link to={`/externalapi/${version}/v/${projectId}/salesforce`} className="nav-link">
                  <span className="circle">
                    <img
                      src={require('../dataSource/img/salesforce.svg')}
                      width="18"
                      height="18"
                      alt="Salesforce"
                    />
                  </span>
                  &nbsp;Salesforce
                </Link>
              </li>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default ExternalSourceHeaderNav;
